
const {ccclass, property} = cc._decorator;

//德州扑克动画使用
@ccclass
export default class TexasAnimEffect extends cc.Component {

    @property([cc.Animation])
    animation:cc.Animation[] = [];

    //播放动画
    playAllAnim(){
        for (let am of this.animation) {
            if (am.node.active) {
                am.play();
            }
        }
    }

    playAnim(index:number){
        let anim = this.animation[index];
        if (anim && anim.node.active) {
            anim.play();
        }
    }

    stopAnim(index:number){
        let anim = this.animation[index];
        if (anim && anim.node.active) {
            anim.setCurrentTime(0)
            anim.pause();
        }
    }
}
